import firebase from 'firebase/app';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyBNXb6lWxsUd1zrkopE9dFA4tdH80I8ldw',
  authDomain: 'workpath-website.firebaseapp.com',
  projectId: 'workpath-website',
  storageBucket: 'workpath-website.appspot.com',
  messagingSenderId: '39632518512',
  appId: '1:39632518512:web:d945c8938e3a70ff95e3b5',
  measurementId: 'G-PQLC2XSGS8',
};

firebase.initializeApp(firebaseConfig);
export default firebase;
export const db = firebase.firestore();
